import { useLayoutEffect } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5hierarchy from "@amcharts/amcharts5/hierarchy";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { SUNBURST_DATA } from '../../../../data/sunburstData';

export default function SunBurstChart() {
  const getSelectedValues = (selectedValue: any) => {
    const category = selectedValue?._settings?.category;
    const childCount = selectedValue?._settings?.childData?.length;
    const array = selectedValue?._settings?.childData.map((x: { children: string | any[]; }) => {
      return x.children?.length;
    }) || [];
    const childCount2 = array.reduce((partialSum: any, a: any) => partialSum + a, 0) || 0;

    return { category, childCount, childCount2 }
  };

  useLayoutEffect(() => {
    let root = am5.Root.new("sunburstChart");
    root.setThemes([
      am5themes_Animated.new(root),
      am5themes_Responsive.new(root)
    ]);

    let container = root.container.children.push(am5.Container.new(root, {
      width: am5.percent(100),
      height: am5.percent(100),
      layout: root.verticalLayout
    }));

    // Create series
    let series = container.children.push(am5hierarchy.Sunburst.new(root, {
      singleBranchOnly: false,
      downDepth: 3,
      initialDepth: 3,
      topDepth: 1,
      upDepth: 3,
      innerRadius: 200,
      valueField: "value",
      categoryField: "name",
      childDataField: "children",
    }));

    series.nodes.template.setAll({
      tooltipText: "{category}"
    });

    series.slices.template.setAll({
      templateField: "nodeSettings",
      stroke: am5.color(0x000000),
    });

    series.labels.template.setAll({
      paddingLeft: 5,
      paddingRight: 5,
      paddingTop: 5,
      paddingBottom: 5,
      baseRadius: am5.p50,
      centerX: am5.p50,
      fontSize: 19,
      breakWords: true,
      textAlign: "start"
    });

    series.data.setAll(SUNBURST_DATA);
    series.set("selectedDataItem", series.dataItems[0]);
    const { category: categoryValue, childCount, childCount2 } = getSelectedValues(series.dataItems[0]);
    container.children.push(am5.Label.new(root, {
      text: categoryValue,
      textAlign: "center",
      x: am5.p50,
      y: am5.p50,
      centerX: am5.p50,
      centerY: 100,
      fontSize: 35,
      fontWeight: "300",
      fill: am5.color("#FFFFFF")
    }));

    container.children.push(am5.Label.new(root, {
      text: `${childCount} Risks | ${childCount2} Controls`,
      textAlign: "center",
      x: am5.p50,
      y: am5.p50,
      centerX: am5.p50,
      centerY: 50,
      fontSize: 19,
      fontWeight: "300",
      fill: am5.color("#BDBDC5")
    }));

    series.events.on('click', (e) => {
      const selectedDataItem = e?.target?._settings?.selectedDataItem || {};
      const { category, childCount, childCount2 } = getSelectedValues(selectedDataItem);
      container.children.setIndex(1, am5.Label.new(root, {
        text: category,
        textAlign: "center",
        x: am5.p50,
        y: am5.p50,
        centerX: am5.p50,
        centerY: 100,
        fontSize: 35,
        fontWeight: "300",
        fill: am5.color("#FFFFFF")
      }));

      container.children.setIndex(2, am5.Label.new(root, {
        text: `${childCount} Risks | ${childCount2} Controls`,
        textAlign: "center",
        x: am5.p50,
        y: am5.p50,
        centerX: am5.p50,
        centerY: 50,
        fontSize: 19,
        fontWeight: "300",
        fill: am5.color("#BDBDC5")
      }));
    }
    );

    root._logo?.dispose();

    return () => {
      root.dispose();
    }
  }, []);

  return (
    <div id="sunburstChart" style={{ width: "100%", height: "1000px" }}></div>
  );
}
